module.exports = __webpack_public_path__ + "static/media/20.80eb40c9.jpeg";